import React from 'react';
import { Home, Megaphone, Gift, Users } from 'lucide-react';

const ManagerSidebar: React.FC = () => {
  const currentPath = window.location.pathname;

  const handleNavigation = (path: string) => {
    window.location.href = path;
  };

  return (
    <aside className="relative left-0 mt-0 bg-white border-r border-gray-100">
      <nav className="px-2 py-4 space-y-1">
        <button
          onClick={() => handleNavigation('/manager')}
          className={`w-full flex items-center space-x-3 px-3 py-2 rounded ${
            currentPath === '/manager'
              ? 'bg-brown-100 text-brown-700'
              : 'text-gray-700 hover:bg-gray-50'
          }`}
        >
          <Home className="w-5 h-5" />
          <span>Início</span>
        </button>
        <button
          onClick={() => handleNavigation('/profiles')}
          className={`w-full flex items-center space-x-3 px-3 py-2 rounded ${
            currentPath === '/profiles'
              ? 'bg-brown-100 text-brown-700'
              : 'text-gray-700 hover:bg-gray-50'
          }`}
        >
          <Users className="w-5 h-5" />
          <span>Perfis</span>
        </button>
        <button className="w-full flex items-center space-x-3 px-3 py-2 text-gray-700 hover:bg-gray-50 rounded">
          <Megaphone className="w-5 h-5" />
          <span>Campanhas</span>
        </button>
        <button className="w-full flex items-center space-x-3 px-3 py-2 text-gray-700 hover:bg-gray-50 rounded">
          <Gift className="w-5 h-5" />
          <span>Doações</span>
        </button>
      </nav>
    </aside>
  );
};

export default ManagerSidebar;


